import { takeLatest, call, select, put } from 'redux-saga/effects'
import {
    GET_RESERVATION,
    SET_RESERVATION,
    CREATE_RESERVATION,
    GET_ROOM_DAY,
    DETAIL_RESERVATION,
    CANCEL_RESERVATION,
    UPDATE_RESERVATION,
    SET_KEYCLOAK,
    CHECK_TOKEN_EXPIRE,
    BYPASS_TOKEN
} from '../actions/type'
import { showSpinner, hideSpinner } from '../actions/actions'
import {
    getSelector,
    getHttpClient,
    apiHelper,
    deleteHttpClient,
    genVRoomToken,
    getLandingUpcoming,
} from '../../helpers'
import { get, isEmpty } from 'lodash'
import moment from 'moment'
import Keycloak from "keycloak-js";
import { destroyUserInfo } from '../../helpers';

const keycloakSelector = getSelector('keycloak')
const reservationListSelector = getSelector('reservation.reservationList')
const languageSelector = getSelector('language')

async function onKeycloak() {
    await new Promise(r => setTimeout(r, 500));
    const keycloak = Keycloak({ clientId: window._env_.clientid, realm: window._env_.realm, url: window._env_.keycloak_url });
    await keycloak
        .init({
            onLoad: "check-sso",
            checkLoginIframe: false,
            silentCheckSsoRedirectUri:
                window.location.origin + "/" + process.env.PUBLIC_URL + "/silent-check-sso.html",
        })
    return keycloak
}

function* checkTokenExpire() {
    const keycloak = yield call(onKeycloak)
    const token = yield call(genVRoomToken, keycloak)
    const language = yield select(languageSelector)

    yield put({
        type: SET_KEYCLOAK,
        payload: {
            keycloak: keycloak
        }
    })
    if (isEmpty(token)) {
        destroyUserInfo()
        window.location.href = keycloak.createLoginUrl() + `&ui_locales=${language}`
    }
}

function* bypassToken({ payload }) {
    const { room, pause, hash} = payload
    if (isEmpty(room)) {
        window.location.href = '/portal'
    }
    const keycloak = yield call(onKeycloak)
    const token = yield call(genVRoomToken, keycloak)
    yield put({
        type: SET_KEYCLOAK,
        payload: {
            keycloak: keycloak
        }
    })
    if (!isEmpty(token)) {
        if (pause)
            console.log(`${window._env_.vRoomUrl}/${room}${hash}`);
        else
            window.location.href = `${window._env_.vRoomUrl}/${room}${hash}`
    } else {
        const vtoken = localStorage.getItem('vtoken')
        if (pause) {
            if (!isEmpty(vtoken) && keycloak.authenticated) {
                console.log(`${window._env_.vRoomUrl}/${room}?isTokenFail=true${hash}`)
            }
        } else {
            if (!isEmpty(vtoken) && keycloak.authenticated) {
                window.location.href = `${window._env_.vRoomUrl}/${room}?isTokenFail=true${hash}`
            }
        }
    }
}

function* getReservation() {
    const { dateNow, lastDate } = getLandingUpcoming()
    // const { startDate, endDate } = payload
    const userInfo = yield call(onKeycloak)
    yield put({
        type: SET_KEYCLOAK,
        payload: {
            keycloak: userInfo,
            authenticated: userInfo.authenticated
        }
    })
    const keycloak = yield select(keycloakSelector)
    const url = window._env_.reservation + apiHelper.getReservations(dateNow, lastDate)
    let activeItem = 0
    try {
        if (keycloak.authenticated) {
            const token = yield call(genVRoomToken, keycloak)
            const response = yield call(getHttpClient, keycloak, url, { Authorization: "Bearer " + token })
            const reservationList = response.sort((a, b) => {
                return a.start_dt - b.start_dt
            })
            activeItem = get(reservationList, '[0].id', 0)
            const filterReservation = reservationList.filter(reservation => Date.parse(new Date()) <= reservation.end_dt)
            yield put({
                type: SET_RESERVATION,
                payload: {
                    reservationList: filterReservation,
                    reservationItems: reservationList,
                    activeItem
                }
            })
        }
    } catch (err) {
        // Do not anything
    }
}

function* cancelReservation({ payload }) {
    const { id } = payload
    const keycloak = yield select(keycloakSelector)
    const reservationList = yield select(reservationListSelector)
    const url = window._env_.reservation + apiHelper.cancelReservation(id)
    yield put(showSpinner)
    try {
        const token = yield call(genVRoomToken, keycloak)
        const response = yield call(deleteHttpClient, keycloak, url, { Authorization: "Bearer " + token })
        if (isEmpty(response)) {
            const findId = (item) => item.id === id;
            const index = reservationList.findIndex(findId)
            reservationList.splice(index, 1)
            const activeItem = get(reservationList, '[0].id', 0)
            yield put({
                type: SET_RESERVATION,
                payload: {
                    reservationList,
                    reservationItems: reservationList,
                    activeItem
                }
            })
        }
    } catch (err) {
        // Do not anything
    }
    yield put(hideSpinner)
}

function* getRoomByDay({ payload }) {
    const { selectDay } = payload
    const reservationList = yield select(reservationListSelector)
    const reservationItems = reservationList.filter(item => {
        const dateConvert = moment(item.start_dt).format('D/MM/Y')
        return dateConvert === selectDay
    })
    const activeItem = get(reservationItems, '[0].id', 0)
    yield put({
        type: SET_RESERVATION,
        payload: {
            activeItem
        }
    })
}

function* createReservation({ payload }) {
    let list = yield select(reservationListSelector)
    list.push(payload)
    const reservationList = list.sort((a, b) => {
        return a.start_dt - b.start_dt
    })
    const activeItem = get(reservationList, '[0].id', 0)
    yield put({
        type: SET_RESERVATION,
        payload: {
            reservationList,
            reservationItems: reservationList,
            activeItem
        }
    })
}

function* updateReservation({ payload }) {
    let list = yield select(reservationListSelector)
    let reservationList = list.map(el => el.id === payload.id ? payload : el)
    yield put({
        type: SET_RESERVATION,
        payload: {
            reservationList,
            reservationItems: reservationList,
        },
    })
}

function* getReservationByid({ payload }) {
    const { activeItem } = payload
    const keycloak = yield select(keycloakSelector)
    const urlReservation = `${window._env_.reservation}api/v1/reservations/${activeItem}`
    try {
        const token = yield call(genVRoomToken, keycloak)
        const reservationDetail = yield call(getHttpClient, keycloak, urlReservation, { Authorization: "Bearer " + token })
        yield put({
            type: SET_RESERVATION,
            payload: {
                reservationDetail,
            }
        })
    } catch (err) {
        console.log('get reservation by id', err)
    }
}

function* reservationSaga() {
    yield takeLatest(GET_RESERVATION, getReservation)
    yield takeLatest(CREATE_RESERVATION, createReservation)
    yield takeLatest(DETAIL_RESERVATION, getReservationByid)
    yield takeLatest(GET_ROOM_DAY, getRoomByDay)
    yield takeLatest(CANCEL_RESERVATION, cancelReservation)
    yield takeLatest(UPDATE_RESERVATION, updateReservation)
    yield takeLatest(CHECK_TOKEN_EXPIRE, checkTokenExpire)
    yield takeLatest(BYPASS_TOKEN, bypassToken)
}

export default reservationSaga
